import AttentionMsg from './AttentionMsg';

export default AttentionMsg;
